export default {
  'tour.name': 'Nome del tour',
  'tour.en.name': 'Nome del tour Italiano',
  'tour.en.fa.name': 'Nome del tour persiano',
  'tour.englishTourName': 'Nome del tour (in inglese)',
  'tour.persianTourName': 'Nome del tour (in persiano)',
  'tour.necessities': 'Necessità Inglese',
  'tour.en.necessities': 'Necessità in inglese',
  'tour.en.fa.necessities': 'Necessità in persiano',
  'tour.englishNecessities':
    'Elementi essenziali necessari per il viaggio (in inglese)',
  'tour.persianNecessities':
    'Elementi essenziali necessari per il viaggio (in persiano)',
  'tour.moneyUnit': 'Unità monetaria',
  'tour.price': 'Prezzo',
  'tour.setPrice': 'Imposta prezzo',
  'tour.type': 'Tipo di tour',
  'tour.registerDate': 'Data di registrazione',
  'tour.whether': 'Se',
  'tour.tourCondition': 'Condizioni del tour',
  'tour.passengerTypes': 'Tipi di passeggeri',
  'tour.choosePassengerTypes': 'Scegli il tipo di passeggero',
  'tour.capacity': 'Capacità del numero di persone nel tour',
  'tour.duration': 'Durata del tour (giorni)',
  'tour.destination': 'Destinazione',
  'tour.destinationCity': 'città di destinazione',
  'tour.destinationCountry': 'Paese di destinazione',
  'tour.en.destination': 'Nome destinazione Italiano',
  'tour.en.fa.destination': 'Nome destinazione persiano',
  'tour.description': 'descrizione',
  'tour.en.description': 'descrizione in inglese',
  'tour.en.fa.description': 'descrizione in persiano',
  'tour.englishDescription':
    'Menzionare i dettagli richiesti per il viaggio (in inglese)',
  'tour.persianDescription':
    'Menzionare i dettagli richiesti per il viaggio (in persiano)',
  'tour.limitaions': 'Limitazioni',
  'tour.en.limitaions': 'Limitazioni in inglese',
  'tour.englishlimitaions': 'Limitazioni di viaggio (in inglese)',
  'tour.persianlimitaions': 'Limitazioni di viaggio (in persiano)',
  'tour.departure': 'partenza',
  'tour.departureCity': 'Città di partenza',
  'tour.departureCountry': 'Paese di partenza',
  'tour.en.departure': 'partenza',
  'tour.en.fa.departure': 'partenza in persiano',
  'tour.difficultyRate': 'Difficoltà di viaggio',
  'tour.departureDate': 'Orario di inizio del tour',
  'tour.international': 'internazionale',
  'tour.domestic': 'domestica',
  'tour.addTour': 'Aggiungi un nuovo tour',
  'tour.easy': 'Facile',
  'tour.amature': 'amatoriale',
  'tour.normal': 'Normale',
  'tour.hard': 'Difficile',
  'tour.veryHard': 'Molto difficile',
  'tour.road': 'Strada',
  'tour.flight': 'Volo',
  'tour.marine': 'Marina',
  'tour.transportTypes': 'Tipi di trasporto',
  'tour.chooseTransportTypes': 'Scegli i tipi di trasporto',
  'tour.surpriseTour': 'Tour a sorpresa',
  'tour.ordinaryTour': 'Ordinary Tour',
  'tour.next': 'Passo successivo',
  'tour.home': 'Casa',
  'tour.confirm': 'Confermare',
  'tour.previous': 'passo precedente',
  'tour.active': 'Attiva',
  'tour.disable': 'disattivare',
  'tour.dollar': 'Dollaro Americano',
  'tour.euro': 'Eura',
  'tour.rial': 'Rial',
  'tour.stepOne': 'Passo 1',
  'tour.stepTwo': 'Passo 2',
  'tour.stepThree': 'Passo 3',
  'tour.stepFour': 'Passo 4',
  'tour.stepFive': 'Passo 5',
  'tour.details': 'Dettagli',
  'tour.tourDetails': 'Dettagli del tour',
  'tour.cancel': 'Annulla',
  'tour.chooseTourType': 'Scegli il tuo tipo',
  'tour.save': 'Salva',
  'tour.tourDetail': 'Informazioni sul tour',
  'tour.furtherInformation': 'Ulteriori informazioni',
  'tour.toddlerinownsitPrice': 'Prezzo per un bambino nella propria seduta',
  'tour.infantPrice': 'Prezzo per un neonato',
  'tour.childPrice': 'Prezzo per un bambino',
  'tour.adultPrice': 'Prezzo per un adulto',
  'tour.studentPrice': 'Prezzo per uno studente',
  'tour.seniorcitizenPrice': 'Prezzo per un anziano',
  'tour.bookingDeadline': "Scadenza per l'iscrizione al Tour",
  'tour.climateType': 'tempo durante il viaggio',
  'tour.step': 'Fare un passo',
  'tour.tourclimateTitle': 'Tour Clima',
  'tour.tourclimateDescription': 'Scegli il tipo di tempo che desideri',
  'tour.tourtypeTitle': 'Tipo di tour',
  'tour.tourtypeDescription': 'Seleziona il tipo di tour che desideri',
  'tour.tourtransfertypeTitle': 'Tipo di trasporto',
  'tour.tourtransfertypeDescription':
    'Seleziona il tipo di trasporto che desideri',
  'tour.tourpassengertypeTitle': 'Tipo di passeggeri',
  'tour.tourpassengertypeDescription':
    'Seleziona il tipo di passeggeri che desideri',
  'tour.tourinformationTitle': 'Informazioni sul tour',
  'tour.tourinformationDescription':
    'Inserisci le informazioni complete sul tour',
  'tour.touroverviewTitle': 'Panoramica del tour',
  'tour.touroverviewDescription':
    'Rivedi le informazioni del tour selezionato e modificale se necessario',
  'tour.tourpriceTitle': 'Prezzo del tour ',
  'tour.overview': 'panoramica ',
  'tour.tourpriceDescription':
    'Inserisci i prezzi per ogni tipo di passeggero di tua scelta',
  'tour.tourScheduling': 'Programmazione del tour',
  'tour.mainTourInformation': 'Informazioni principali sul tour',
  'tour.tourConditions': 'Condizioni del tour',
  'tour.tourRestrictionsRequirements': 'Restrizioni e requisiti del tour',
  'tour.tourRegistration': 'Registrazione del tour',
  'tour.addNewTour': 'Aggiungi un nuovo tour',
  'tour.tourInformationTemporarilyRecorded':
    'Le informazioni sul tour sono state temporaneamente registrate',
  'tour.yourTourSuccessfullyRegistered':
    'Il tuo tour è stato registrato con successo',
  'tour.tourpassengertype': 'Tipo di passeggero',
  'tour.tourtransfertype': 'Trasferimento Tour',
  'tour.tourType': 'Tipo di tour',
  'tour.nameen': 'Nome del tour (in inglese)',
  'tour.namefa': 'Nome del tour (in persiano)',
  'tour.bookingDeadLine': "Scadenza per l'iscrizione al Tour",
  'tour.climateTypes': 'Tour Clima',
  'tour.limitationsen': 'Limitazioni di viaggio (in inglese)',
  'tour.limitationsfa': 'Limitazioni di viaggio (in persiano)',
  'tour.necessitiesen':
    'Elementi essenziali necessari per il viaggio (in inglese)',
  'tour.necessitiesfa':
    'Elementi essenziali necessari per il viaggio (in persiano)',
  'tour.descriptionen':
    'Menzionare i dettagli richiesti per il viaggio (in inglese)',
  'tour.descriptionfa':
    'Menzionare i dettagli richiesti per il viaggio (in persiano)',
  'tour.editTourTransferType':
    'Modifica le informazioni sul trasferimento del tour',
  'tour.editTourPassengerType':
    'Modifica le informazioni sui passeggeri e i prezzi per ogni passeggero',
  'tour.editTourInformation': 'Modifica le informazioni generali sul tour',
  'tour.tourRegistration': 'Registrazione del tour',
  'tour.isActive': 'Attiva',
  'tour.editTourPassengerType': 'Modifica il tipo di passeggero del tour',
  'tour.editTourTransferType': 'Modifica il tipo di trasferimento del tour',
  'tour.editTourInformationType': 'Modifica le informazioni sul tour',
  'tour.editTourPrice': 'Modifica prezzo passeggero',
  'tour.attachments': 'Allegati',
  'tour.cancelingRules': 'Regole di annullamento',
  'tour.endBookingDeadLine': 'Fine Scadenza Prenotazione',
  'tour.endPrice': 'Prezzo finale',
  'tour.startPrice': 'Prezzo di partenza',
  'tour.endDuration': 'Fine Durata',
  'tour.startDuration': 'Inizio Durata',
  'tour.endDepartureDate': 'Data di fine partenza',
  'tour.startDepartureDate': 'Data di partenza di inizio',
  'tour.originterminal': 'Terminale di origine',
  'tour.destinationterminal': 'terminale di destinazione',
  'tour.vehicletype': 'Tipo di veicolo',
  'tour.starttime': 'Ora di inizio',
  'tour.endtime': 'Tempo scaduto',
  'tour.invalidreturndate': 'Data di fine inferiore alla data di inizio',
  'tour.invalidstartdate': 'Data di inizio successiva alla data di fine',
  'tour.facilities': 'Strutture turistiche',
  'tour.invalidEndTime': "Ora di fine inferiore all'ora di inizio",
  'tour.drafts': 'bozze',
  'tour.useprevioustours': 'Utilizzo dei tour precedenti',
  'tour.Draft': 'Progetti di tour',
  'tour.creationDate': 'data di creazione',
  'tour.dateCreatedFrom': 'Data di creazione da',
  'tour.dateCreatedUntil': 'Data di creazione fino al',
  'tour.ordering': 'Ordinare',
  'tour.basedTourName': 'In base al nome del tour',
  'tour.basedNamePlace': 'In base al nome del luogo',
  'tour.search': 'Cerca per nome e posizione',
  'tour.facilitynotdeclared': "l'impianto non è dichiarato",
  'tour.basicinfonotfound': 'le informazioni sul tour non sono specificate',
  'tour.finaldestination': 'destinazione finale',
  'tour.insertdraft': 'inserire bozza',
  'tour.updatetdraft': 'bozza di aggiornamento',
  'tour.ageSuffering': "sofferenze dell'età",
  'tour.finaldestination': 'destinazione finale',
  'tour.insertsuccess': 'Il tour è stato registrato con successo',
  'tour.draftinsertsuccess':
    'La bozza del tour è stata registrata con successo',
  'tour.inserterror': 'La registrazione del tour non è riuscita',
  'tour.updatesuccess': 'Il tour è stato aggiornato con successo',
  'tour.draftupdatesuccess':
    'La bozza del tour è stata aggiornata con successo',
  'tour.updateerror': "L'aggiornamento del tour non è riuscito",
  'tour.deletesuccess': 'Il tour è stato eliminato con successo',
  'tour.draftdeletesuccess': 'La bozza del tour è stata eliminata con successo',
  'tour.deleteerror': "L'eliminazione del tour non è riuscita",
  'tour.deletedrafttour': 'Elimina la bozza del tour',
  'tour.deletedrafttourmessage':
    'Sei sicuro di voler eliminare la bozza del tour?',
  'tour.male': 'maschio',
  'tour.female': 'femmina',
  'tour.all': 'Tutto',
  'tour.changefieldwarning':
    'Se vengono apportate modifiche nei campi importanti, le informazioni dei passaggi successivi verranno eliminate. Fare clic per ulteriori informazioni',
  'tour.importantfieldsintroduction':
    'applicare modifiche ai seguenti campi causerà la perdita dei dati dei moduli successivi',
  'tour.tournotspecified': 'le informazioni sul tour non sono specificate',
  'tour.stoptype': 'tipo di fermata',
  'tour.searchfacilities': 'Strutture di ricerca',
  'tour.confirmdata': 'Tutte le informazioni registrate sono verificate',
  'tour.vehiclenamefa': 'nome del veicolo locale',
  'tour.vehiclenameen': 'nome inglese del veicolo',
  'tour.transportproviderlocal': 'Nome locale del fornitore di trasporti',
  'tour.transportprovideren': 'Nome inglese del fornitore di trasporti',
  'tour.addnewtourtype': 'Aggiungi un nuovo tipo di tour',
  'tour.submittourtype': 'inviare un nuovo tipo di tour',
  'tour.tourtypenamefa': 'Nome Farsi del tipo di tour',
  'tour.tourtypenameen': 'Nome inglese del tipo di tour',
  'tour.tourtypeinsertsuccess': 'inserire con successo',
  'tour.tourtypeinserterror': 'inserimento non riuscito',
  'tour.originairport': 'aeroporto di origine',
  'tour.destinationairport': 'aeroporto di destinazione',
  'tour.arrivaldateto': "data d'arrivo",
  'tour.arrivaltimeto': 'orario di arrivo',
  'tour.nextmovedate': 'prossima data di inizio trasporto',
  'tour.nextmovetime': 'prossima ora di inizio del trasporto',
  'tour.tourimages': 'immagini del giro',
  'tour.viewimages': 'visualizzare le immagini',
  'tour.addnewtourfacility': 'Aggiunta di nuove strutture turistiche',
  'tour.tourfacilitynamefa': 'Nome farsi delle strutture turistiche',
  'tour.tourfacilitynameen': 'Nome inglese delle strutture turistiche',
  'tour.originterminalfa': 'Nome locale del terminale di origine',
  'tour.originterminalen': 'Nome inglese del terminale di origine',
  'tour.destinationterminalfa': 'Nome locale del terminale di destinazione',
  'tour.destinationterminalen': 'Nome inglese del terminale di destinazione',
  'tour.underreviewing': 'in corso di revisione',
  'tour.expired': 'scaduta',
  'tour.residence': 'residenza',
  'tour.pricepercustomer': 'prezzo per persona',
  'tour.userstours': 'i miei tour',
  'tour.usersalltours': 'tutti i tour',
  'tour.usersactivetours': 'tour attivi',
  'tour.usersexpiredtours': 'tour scaduti',
  'tour.changerequiredfields':
    "mostra il risultato della revisione dell'operatore",
  'tour.requiredreviews': 'revisioni richieste',
  'tour.rejectionreason': 'motivo del rifiuto',
  'tour.rejectiondescription': 'descrizione del rifiuto',
  'tour.starttime': 'Ora di inizio',
  'tour.endtime': 'Tempo scaduto',
  'tour.imageuploadfailed': 'Caricamento immagine non riuscito',
};
